import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import {
  Box,
  Step,
  Stepper,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
} from '@mui/material';
// components
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const STEPS = ['제안 확인', '사전 미팅', '조건 협의', '계약'];

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    borderRadius: 1,
    backgroundColor: theme.palette.divider,
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  zIndex: 1,
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.disabled,
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
  ...(ownerState.active && {
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
  }),
  ...(ownerState.completed && {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
  }),
}));

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  completed: PropTypes.bool,
  icon: PropTypes.number,
};

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <Iconify icon="eva:search-outline" width={24} height={24} />,
    2: <Iconify icon="eva:video-outline" width={24} height={24} />,
    3: <Iconify icon="eva:clipboard-outline" width={24} height={24} />,
    4: <Iconify icon="eva:edit-2-outline" width={24} height={24} />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

export default function CandidateProcessStepper({ status }) {
  const [step, setStep] = useState(0);

  const setProcessStep = () => {
    if (status === "waiting-3way-meeting") setStep(1);
    if (status === "confirm-3way-meeting") setStep(1);
    if (status === "waiting-offer-from-crew") setStep(1);
    if (status === "crew-negotiate-to-company") setStep(2);
    if (status === "company-negotiate-rewrite") setStep(2);
    if (status === "accept") setStep(3);
  }

  useEffect(() => {
    setProcessStep();
  }, [status]);

  if (!status) return <></>;

  return (
    <>
      <Stepper alternativeLabel activeStep={step} connector={<ColorlibConnector />}>
        {STEPS.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Box sx={{ mb: 6 }} />
    </>
  );
}
